import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, Switch, CardHeader, MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import PageHeader from 'src/views/Common/PageHeader';
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }

}));

const screenCode = 'ITEMCATEGORYCREATION';
export default function ItemCategoryAddEdit(props) {
  const [title, setTitle] = useState("Item Category Creation")
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const classes = useStyles();
  const [groups, setGroups] = useState()
  const [factories, setFactories] = useState()
  const [itemCategory, setItemCategory] = useState({
    groupID: 0,
    factoryID: 0,
    categoryCode: '',
    categoryName: '',
    shortCode: '',
    categoryDescription: '',
    isActive: true
  });

  const navigate = useNavigate();
  const handleClick = () => {

    navigate('/app/itemCategory/listing');

  }
  const alert = useAlert();
  const { itemCategoryID } = useParams();
  let decrypted = 0;

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  useEffect(() => {
    decrypted = atob(itemCategoryID.toString());
    if (decrypted != 0) {
      trackPromise(GetItemCategoryDetailsByItemCategoryID(decrypted));
    }
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown())
  }, [itemCategory.groupID]);

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(itemCategory.groupID);
    setFactories(factories);
  }

  async function GetItemCategoryDetailsByItemCategoryID(itemCategoryID) {
    let response = await services.GetItemCategoryDetailsByItemCategoryID(itemCategoryID);
    let data = response[0];
    setTitle("Edit Item Category");
    setItemCategory(data);
    setIsUpdate(true);

  }
  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITITEMCATEGORY');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    if (decrypted == 0) {
      setItemCategory({
        ...itemCategory,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      })
    }
  }

  async function SaveItemCategory(values) {
    if (isUpdate == true) {

      let updateModel = {
        groupID: parseInt(values.groupID),
        factoryID: parseInt(values.factoryID),
        itemCategoryID: atob(itemCategoryID.toString()),
        categoryCode: values.categoryCode,
        categoryName: values.categoryName,
        shortCode: values.shortCode,
        categoryDescription: values.categoryDescription,
        isActive: values.isActive,
        modifiedBy: parseInt(tokenService.getUserIDFromToken())
      }

      let response = await services.UpdateItemCategory(updateModel);
      if (response.statusCode === "Success") {
        alert.success(response.message);
        setIsDisableButton(true);
        navigate('/app/itemCategory/listing');
      }
      else {
        alert.error(response.message);
        setItemCategory({
          ...itemCategory,
          isActive: true
        });
      }
    } else {

      let response = await services.SaveItemCategory(values, tokenService.getUserIDFromToken());
      if (response.statusCode == "Success") {
        alert.success(response.message);
        setIsDisableButton(true);
        navigate('/app/itemCategory/listing');
      }
      else {
        alert.error(response.message);
      }
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
      }
    }
    return items
  }

  function handleChange1(e) {
    const target = e.target;
    const value = target.value
    setItemCategory({
      ...itemCategory,
      [e.target.name]: value
    });
  }

  function handleChangeSwitch() {
    setItemCategory({
      ...itemCategory,
      isActive: !itemCategory.isActive
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: itemCategory.groupID,
              factoryID: itemCategory.factoryID,
              categoryCode: itemCategory.categoryCode,
              categoryName: itemCategory.categoryName,
              shortCode: itemCategory.shortCode,
              categoryDescription: itemCategory.categoryDescription,
              isActive: itemCategory.isActive
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
                categoryCode: Yup.string().max(10, "Item Category Code must be lower than 10 characters").required('Item Category Code is required').matches(/^[A-Za-z0-9]*$/, 'Special Characters not allowed'),
                categoryName: Yup.string().max(50, "Item Category Name must be at most 50 characters").required('Item Category Name is required'),
                shortCode: Yup.string().when([], {
                  is: () => itemCategory.shortCode != null,
                  then: Yup.string().max(2, "Short Code must be at most 2 characters").required('Short Code is required'),
                  otherwise: Yup.string().nullable(),
                }),
                categoryDescription: Yup.string().max(100)
              })
            }
            onSubmit={SaveItemCategory}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              handleChange,
              isSubmitting,
              touched,
              values,
              props
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />

                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange1(e)}
                              size='small'
                              value={itemCategory.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange1(e)}
                              value={itemCategory.factoryID}
                              size='small'
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>

                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="categoryCode">
                              Item Category Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.categoryCode && errors.categoryCode)}
                              fullWidth
                              helperText={touched.categoryCode && errors.categoryCode}
                              name="categoryCode"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange1(e)}
                              value={itemCategory.categoryCode}
                              size='small'
                              variant="outlined"
                              disabled={isDisableButton}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="categoryName">
                              Item Category Name *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.categoryName && errors.categoryName)}
                              fullWidth
                              helperText={touched.categoryName && errors.categoryName}
                              name="categoryName"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange1(e)}
                              value={itemCategory.categoryName}
                              size='small'
                              variant="outlined"
                              disabled={isDisableButton}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="shortCode">
                              Short Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.shortCode && errors.shortCode)}
                              fullWidth
                              helperText={touched.shortCode && errors.shortCode}
                              name="shortCode"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange1(e)}
                              value={itemCategory.shortCode}
                              size='small'
                              variant="outlined"
                              disabled={isDisableButton}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="categoryDescription">
                              Description
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.categoryDescription && errors.categoryDescription)}
                              fullWidth
                              helperText={touched.categoryDescription && errors.categoryDescription}
                              name="categoryDescription"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange1(e)}
                              size='small'
                              value={itemCategory.categoryDescription}
                              variant="outlined"
                              disabled={isDisableButton}
                              multiline={true}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="isActive">
                              Active
                            </InputLabel>
                            <Switch
                              checked={itemCategory.isActive}
                              onChange={handleChangeSwitch}
                              name="isActive"
                              disabled={isDisableButton}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          disabled={isSubmitting || isDisableButton}
                          type="submit"
                          size='small'
                          variant="contained"
                        >
                          {isUpdate == true ? "Update" : "Save"}
                        </Button>
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
};
